import { Suspense, lazy } from 'react';
import type { SlotEntry } from '@saas/ui';

/**
 * 画面の差し込み口（`@saas/ui` の `Slot`）に conversation が出すもの。登録は apps/web（リード）が行う。
 * 部品は `lazy` + `Suspense`（初期バンドルを太らせない）。中身が空なら null を返して場所を取らない
 */
const MyInboxPanel = lazy(() => import('./components/MyInboxPanel.js'));

export const conversationSlots: SlotEntry[] = [
  {
    id: 'conversation.inbox',
    module: 'conversation',
    slot: 'dashboard.inbox',
    subjectTypes: ['user'],
    permission: ['conversation.message.read'],
    order: 20,
    Component: () => (
      <Suspense fallback={null}>
        <MyInboxPanel />
      </Suspense>
    ),
  },
];
